<template>
  <div class="container">
    <div class="top">
      <p class="total">
        共 <label>{{ total }}</label> 条记录
      </p>
      <div class="search">
        <el-input v-model="keyWords" placeholder="请输入题名、作者、DOI" @keyup.enter.native="toSearch" clearable></el-input>
        <span class="search_img" @click="toSearch">
          <img src="../../assets/images/search_icon.png" />
        </span>
      </div>
    </div>

    <div class="right-item">
      <ul>
        <li class="flex" v-for="(item, index) in list" :key="index">
          <span class="index">{{ (pageNo - 1) * pageSize + index + 1 }}</span>
          <div class="right-info">
            <p class="title" @click="toDetail(item.sid)" v-safe-html="item.title"></p>
            <p v-if="item.authorArray && item.authorArray.length > 0" class="author_a">
              作者:
              <span class="span-content" :class="{ green_span: element.click }" v-for="(element, index) in item.authorArray" :key="index">
                <span class="span_a" @click="toAuthorDetail(element)" v-safe-html="element.authorName"></span>
                <span class="mr5" v-if="index < item.authorArray.length - 1">;</span>
                <div class="author-content">
                  <p class="mb10" v-safe-html="element.authorName"></p>
                  <p>
                    <span v-if="element.hindex != null"
                      >hindex：<label>{{ element.hindex }}</label></span
                    >
                    <span v-if="element.i10Index != null"
                      >i10Index：<label>{{ element.i10Index }}</label></span
                    >
                  </p>
                  <p>
                    <span v-if="element.citedByCount != null"
                      >citedByCount：<label>{{ element.citedByCount }}</label></span
                    >
                    <span v-if="element.worksCount != null"
                      >worksCount：<label>{{ element.worksCount }}</label></span
                    >
                  </p>
                  <p class="hui">{{ element.lastKnownInstitutionName }}</p>
                </div>
              </span>
              <label v-if="item.showauthor && item.authorAllArray.length > 5" class="digestLabel" @click="showauthor(index)">展开</label>
              <label v-if="!item.showauthor" class="digestLabel" @click="closeauthor(index)">收起</label>
            </p>
            <p v-if="item.journalName">
              期刊信息:
              <span class="undline" @click="toHomeDetail(item)">{{ item.journalName }} </span>
              <label v-if="item.year"> ; {{ item.year }}</label>
              <label v-if="item.volume"> ; {{ item.volume }}</label>
              <label v-if="item.issue && item.issue != 'null'">({{ item.issue }})</label>
            </p>
            <p v-if="item.doi">DOI: <span v-safe-html="item.doi"></span></p>
            <p v-if="item.publisherName">出版社: <span v-safe-html="item.publisherName"></span></p>
            <p v-if="item.source">来源: {{ item.source }}</p>
            <a class="btn" @click="removeCollect(index)">取消收藏</a>
          </div>
        </li>
      </ul>
      <div class="noData" v-if="total <= 0">
        <img src="../../assets/images/noData.png" />
      </div>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[10, 20, 30, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" hide-on-single-page> </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "myArticle",
  data() {
    return {
      total: 1,
      pageSize: 10,
      pageNo: 1,
      list: [],
      keyWords: "",
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getString(data) {
      if (data) {
        return data.toString().split(",").join(" ; ");
      }
    },
    getList() {
      let postBody = {
        keyWords: this.keyWords,
        type: 2,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      this.$http({
        url: "api/v1/usershare/list",
        method: "POST",
        data: postBody,
      }).then(res => {
        this.total = res.total;
        this.list = res.rows;
        this.list.forEach((element, index) => {
          element.showauthor = true;
          element.isshow = true;
          if (element.author) {
            this.$set(this.list[index], "authorAllArray", element.authorList);
            this.$set(this.list[index], "authorArray", element.authorAllArray.slice(0, 5));
          }
        });
      });
    },
    removeCollect(index) {
      this.$confirm("是否要取消收藏?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let postBody = {
          outSid: this.list[index].sid,
          type: 2,
        };
        this.$http({
          url: `api/v1/usershare/collect`,
          method: "POST",
          data: postBody,
        }).then(res => {
          if (res.code == 200) {
            this.pageNo = 1;
            this.$message.success("取消收藏成功");
            this.getList();
          }
        });
      });
    },
    toDetail(sid) {
      let _url = this.$router.resolve({
        path: "/articleDetail",
        query: { sid: sid },
      });
      window.open(_url.href, "_self");
    },
    // 期刊信息跳转
    toHomeDetail(item) {
      this.$router.push({
        path: "/homeDetail",
        query: { sid: item.journalSid },
      });
    },
    toSearch() {
      this.pageNo = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getList();
    },
    //作者展开收起
    showauthor(index) {
      this.list[index].showauthor = false;
      this.list[index].authorArray = this.list[index].authorAllArray;
      this.$forceUpdate();
    },
    closeauthor(index) {
      this.list[index].showauthor = true;
      this.list[index].authorArray = [];
      for (let i = 0; i < 5; i++) {
        this.list[index].authorArray.push(this.list[index].authorList[i]);
      }
      this.$forceUpdate();
    },
    // 作者详情跳转
    toAuthorDetail(item) {
      if (item.click) {
        let _url = this.$router.resolve({
          path: "/authorDetail",
          query: { authorSid: item.sid },
        });
        window.open(_url.href, "_self");
      }
      // this.$http({
      //   url: `api/v1/reception/author/checkAuthorJumpDetail?authorSid=${authorSid}`,
      //   method: "get",
      // }).then(res => {
      //   setTimeout(() => {
      //     if (res.code == 200) {
      //       if (res.data) {
      //         let _url = this.$router.resolve({
      //           path: "/authorDetail",
      //           query: { authorSid: authorSid },
      //         });
      //         window.open(_url.href, "_blank");
      //       } else {
      //         this.$message.error("该作者暂无收录");
      //       }
      //     }
      //   }, 500);
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  .right-item {
    background: #fff;
    margin-top: 10px;
    padding: 0 20px;
    ul {
      li {
        padding: 20px 0;
        border-bottom: 1px dashed #eeeeee;
        .index {
          width: 50px;
          line-height: 30px;
        }
        .right-info {
          color: #666666;
          flex: 1;
          min-width: 0;
          .active {
            display: inline-block;
            white-space: nowrap;
            width: 90%;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: bottom;
          }
          .undline {
            text-decoration: underline;
            cursor: pointer;
            &:hover {
              color: #2d8cf0;
            }
          }
          .author_a {
            .green {
              color: #2d8cf0;
              cursor: pointer;
              &:hover {
                text-decoration: underline;
              }
            }
          }
          .btn {
            margin-top: 10px;
            font-size: 14px;
          }
          p {
            line-height: 30px;
          }
          .title {
            &:nth-of-type(1) {
              color: #333;
              font-size: 18px;
              font-weight: bold;
              margin-bottom: 10px;
              cursor: pointer;
            }
          }
          a {
            border-radius: 4px;
            border: 1px solid #2d8cf0;
            color: #2d8cf0;
            font-size: 16px;
            padding: 5px 15px;
            margin-top: 10px;
            display: inline-block;
          }
        }
        &:hover {
          .right-info {
            > p {
              &:nth-of-type(1) {
                background-image: linear-gradient(to right, #006eb3, #2d8cf0);
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
            }
          }
        }
        .span-content {
          position: relative;
          .author-content {
            top: 30px;
            left: 0px;
          }
        }
        .green_span {
          cursor: pointer;
          &:hover {
            .span_a {
              text-decoration: underline;
            }
            transition: all 1s;
            .author-content {
              display: inline-block;
            }
          }
          .span_a {
            color: #2d8cf0;
          }
        }
        .author-content {
          position: absolute;
          background: #fff;
          box-shadow: 0 0 5px #d3d3d3;
          display: none;
          padding: 10px;
          z-index: 9999;
          top: -30px;
          right: -210px;
          min-width: 300px;
          .mb10 {
            font-size: 16px;
            margin-bottom: 10px !important;
          }
          .hui {
            margin-top: 5px !important;
            white-space: pre-wrap;
          }
          p {
            font-size: 14px;
            margin: 0 !important;
            line-height: 20px;
            span {
              position: relative;
              &:first-of-type {
                margin-right: 14px;
                &::before {
                  content: "";
                  position: absolute;
                  width: 1px;
                  height: 14px;
                  background: #ccc;
                  right: -7px;
                  top: 50%;
                  margin-top: -7px;
                }
              }
              label {
                color: #2d8cf0;
              }
            }
          }
        }
      }
    }
  }
  .top {
    display: flex;
    align-items: center;
    padding: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    .total {
      label {
        color: #2d8cf0;
      }
    }
    .search {
      display: flex;
      align-items: center;
      background: #fff;
      border: 1px solid #cccccc;
      margin-left: auto;
      ::v-deep .el-input__inner {
        border: none;
        border-radius: 0;
        height: 30px;
        line-height: 30px;
      }
      ::v-deep .el-input__icon {
        line-height: 30px;
      }
      .el-input {
        width: 280px;
      }
      .search_img {
        width: 40px;
        height: 30px;
        background: #2d8cf0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
  .digestLabel {
    cursor: pointer;
    margin-left: 10px;
    &:hover {
      color: #2d8cf0;
    }
  }
}
</style>
